import React from 'react';
import T from 'prop-types';

import AppIcon from '../../../../components/AppIcon';
import LoadingSpinner from '../../../../components/LoadingSpinner';

const SelectedCompany = ({
  onReset,
  company: { company_name, ticker, icon_url, icon_url_2x, show_company_icon },
}) => {
  const showLoading = !icon_url && !show_company_icon;

  return (
    <div className="finance-free-report-selected-company">
      <div className="selected-company-app-img">
        {showLoading && <LoadingSpinner size="sm" id="report-selected-company" />}
        {icon_url && (
          <AppIcon size={26} url={icon_url} url2x={icon_url_2x} store="unified" withBorder />
        )}
        {show_company_icon && (
          <div className="report-selected-company-placeholder">
            <div className="report-selected-company-icon" />
          </div>
        )}
      </div>

      <div className="text-truncate flex-grow">{`${company_name} (${ticker})`}</div>

      <span className="hicon-close-2" onClick={onReset} />
    </div>
  );
};

SelectedCompany.propTypes = {
  onReset: T.func.isRequired,
  company: T.shape({
    company_name: T.string,
    ticker: T.string,
    icon_url: T.string,
    icon_url_2x: T.string,
    show_company_icon: T.bool,
  }).isRequired,
};

export default SelectedCompany;
